import { render, staticRenderFns } from "./LightboxPhoto.vue?vue&type=template&id=c4e9ae56&"
import script from "./LightboxPhoto.vue?vue&type=script&lang=js&"
export * from "./LightboxPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports